import { render, staticRenderFns } from "./questionIcon.vue?vue&type=template&id=7230b0ea&scoped=true"
import script from "./questionIcon.vue?vue&type=script&lang=js"
export * from "./questionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7230b0ea",
  null
  
)

export default component.exports